import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Reviews } from '../../../../vtex-apps/peer/reviews-and-ratings/Reviews/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { v4 as uuidv4 } from 'uuid';

export default function ReviewsGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ReviewsGroup',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Avaliações (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'review-group-1__flex-row', mzTitle: 'MZ | Avaliações' }, [
				FlexLayoutCol({}, [
					RichText({
						blockClass: 'reviews-group-1-heading',
						text: '### Avaliações',
					}),
					Reviews(),
				]),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--rar-1-heading-color', name: 'Heading' },
			{ from: '--text-color-1', to: '--rar-1-text-color', name: 'Texts' },
			{ from: '--brand-color-primary-pure', to: '--rar-1-details-color', name: 'Details' },
			{ from: '--brand-color-primary-pure', to: '--rar-1-stars-color', name: 'Stars' },
			{ from: '--cta-color-pure', to: '--rar-1-dropdown-color', name: 'Dropdown' },
			{ from: '--white', to: '--rar-1-background-color', name: 'Background' },
			{ from: '--white', to: '--rar-1-review-bg-color', name: 'Review Background' },
			{ from: '--cta-color-pure', to: '--rar-1-review-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--rar-1-review-cta-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--rar-1-review-cta-active', name: 'CTA Active' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--rar-1-inputs-br', name: 'Inputs/CTA/Dropdown' },
			{ from: '--border-radius-none', to: '--rar-1-paging-br', name: 'Paging' },
			{ from: '--border-radius-none', to: '--rar-1-accordion-br', name: 'Accordions' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--rar-1-heading-fw', name: 'Heading' },
			{ from: '--font-weight-700', to: '--rar-1-cta-fw', name: 'CTA/Dropdown' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--rar-1-heading-fs', name: 'Heading' },
			{ from: '--font-size-md', to: '--rar-1-cta-fs', name: 'CTA/Dropdown' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--rar-1-heading-ff', name: 'Heading' },
			{ from: '--main-font', to: '--rar-1-cta-ff', name: 'CTA/Dropdown' },
		],
	},
];
